import { BulkUploadTypes, UploadTypeConfig, uploadTypeConfigMap } from 'constants/bulkUpload';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import useReduxSelector from 'utils/useReduxSelector';
import { useHistory } from 'react-router-dom';
import { BulkUploadStagingDetailsSchemaContract } from 'schemas/BulkUploadStagingDetailsSchema';

export const useBulkUploadTypeConfig = (
  bulkUploadType: BulkUploadTypes,
  stagingRecordData?: BulkUploadStagingDetailsSchemaContract[1] | null,
): UploadTypeConfig => {
  const isRxCurrentAccountMerchant = !!useReduxSelector(loggedInUserSelectors.currentOrganization)
    ?.isRxCurrentAccountMerchant;
  const featureFlags = useReduxSelector(loggedInUserSelectors.features);
  const history = useHistory();

  const uploadTypeConfig = uploadTypeConfigMap[bulkUploadType]?.({
    isRxCurrentAccountMerchant,
    featureFlags,
    history,
    stagingRecordData: stagingRecordData || undefined,
  });

  return uploadTypeConfig;
};
